var paragraph_default = {
  "fontElementMap": "Sx5no",
  "elementSpacing": "OlIbR",
  "text": "wsU3o OlIbR",
  "child": "cluSW"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
